import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseLeftLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Close left side",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.7373 3.89761C4.72148 2.8408 6.12435 2.25 7.78411 2.25H16.2178C17.8772 2.25 19.2796 2.84086 20.2634 3.89773C21.2416 4.94853 21.75 6.39899 21.75 8.02638V15.9736C21.75 17.6019 21.2388 19.0523 20.2598 20.1026C19.2753 21.1588 17.8733 21.75 16.2178 21.75H7.78313C6.12379 21.75 4.72117 21.1592 3.73714 20.1024C2.75872 19.0516 2.25 17.6011 2.25 15.9736V8.02638C2.25 6.39889 2.75873 4.94838 3.7373 3.89761ZM4.835 4.91988C4.15879 5.64599 3.75 6.70868 3.75 8.02638V15.9736C3.75 17.2913 4.15879 18.354 4.83492 19.0802C5.50542 19.8003 6.49437 20.25 7.78313 20.25H16.2178C17.5017 20.25 18.4908 19.8006 19.1625 19.0799C19.8398 18.3533 20.25 17.2905 20.25 15.9736V8.02638C20.25 6.70857 19.8414 5.64585 19.1655 4.91976C18.4952 4.19973 17.5066 3.75 16.2178 3.75H7.78411C6.49478 3.75 5.5056 4.1998 4.835 4.91988Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.458 2.25C15.8722 2.25 16.208 2.58579 16.208 3V21C16.208 21.4142 15.8722 21.75 15.458 21.75C15.0438 21.75 14.708 21.4142 14.708 21V3C14.708 2.58579 15.0438 2.25 15.458 2.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.00141 9.59687C7.2943 9.30397 7.76918 9.30397 8.06207 9.59687L9.40446 10.9393L10.7469 9.59687C11.0397 9.30397 11.5146 9.30397 11.8075 9.59687C12.1004 9.88976 12.1004 10.3646 11.8075 10.6575L10.4651 11.9999L11.807 13.3418C12.0999 13.6347 12.0999 14.1096 11.807 14.4025C11.5141 14.6954 11.0393 14.6954 10.7464 14.4025L9.40446 13.0606L8.06254 14.4025C7.76965 14.6954 7.29478 14.6954 7.00188 14.4025C6.70899 14.1096 6.70899 13.6347 7.00188 13.3418L8.3438 11.9999L7.00141 10.6575C6.70851 10.3646 6.70851 9.88976 7.00141 9.59687Z",
			fill: "currentColor"
		})
	]
});
export default SvgCloseLeftLine;
